import React from 'react'
import { Mutation } from 'react-admin'
import { Button } from '@material-ui/core'

const options = {
  undoable: false,
  onSuccess: {
    notification: { body: 'Budgets linked', level: 'info' },
    refresh: true,
  },
  onFailure: {
    notification: { body: 'Error: budgets can not be linked', level: 'warning' },
  },
}

const LinkBudgetsButton = ({ record, label, status }) => {
  const payload = record
    ? { id: record.membershipReference, data: { id: record.membershipReference, linkBudgetsStatus: status } }
    : {}
  return (
    <Mutation type="UPDATE" resource="memberships" payload={payload} options={options}>
      {activate => (
        <Button label="Link Budgets" onClick={activate}>
          {label}
        </Button>
      )}
    </Mutation>
  )
}

export default LinkBudgetsButton
